import Home from "../../templates/Home/Home";
import Layout from "../../templates/Layout";
import LivingRoom from "../../templates/LivingRoom/LivingRoom";
import Inventory from "../../templates/Inventory/Inventory";
import BedRoom from "../../templates/BedRoom/BedRoom";
import ThankYou from "../../templates/ThankYou/ThankYou";
import AmsRooms from "../../templates/AmsRooms/AmsRooms";
import SingleRoom from "../../templates/SingleRoom/SingleRoom";
import AnotherItem from "../../templates/AnotherItem/AnotherItem";
import AboutBoxes from "../../templates/AboutBoxes/AboutBoxes";
const templatesLibrary: any = {
    "Layout":Layout,
    "Home":Home,
    "LivingRoom":LivingRoom,
    "Inventory":Inventory,
    "BedRoom":BedRoom,
    "ThankYou":ThankYou,
    "AmsRooms":AmsRooms,
    "SingleRoom":SingleRoom,
    "AnotherItem":AnotherItem,
    "AboutBoxes":AboutBoxes
}

export default templatesLibrary;